// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3O64-","options":"AnswerScale_options__EcAdg","selected":"AnswerScale_selected__1TucM"};